import React, { useState } from 'react';
import Icon from '../../../../Assets/Icon/CustomIcon';

export default function InputText({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  required = false,
  disabled = false,
  error = '',
  maxLength,
  inputMode,
}) {
  const [isFocused, setIsFocused] = useState(false);
  const isValid = !error && value?.trim() !== '';

  const getBorderStyle = () => {
    if (error) return '2px solid #E65959';
    if (isFocused) return '2px solid #4C48BE';
    return '2px solid transparent';
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.target.blur();
    }
  };

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}
    >
      {label && (
        <label
          style={{
            fontWeight: 'normal',
            fontSize: '14px',
            color: '#000',
            marginBottom: '4px',
            whiteSpace: 'pre-line', // 줄바꿈 문자를 실제 줄바꿈으로 표시
          }}
        >
          {label}
        </label>
      )}
      <div style={{ position: 'relative', width: '100%' }}>
        <input
          type={type}
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          maxLength={maxLength}
          inputMode={inputMode}
          style={{
            width: '100%',
            padding: '4px',
            /* Tailwind @layer base의 border 초기화와 충돌하지 않도록 longhand만 사용 (하단 밑줄 전용) */
            borderStyle: 'solid',
            borderWidth: 0,
            borderTopWidth: 0,
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderBottom: getBorderStyle(),
            borderRadius: 0,
            fontSize: '16px',
            fontWeight: 'bold',
            transition: 'border-bottom-color 0.2s',
            outline: 'none',
            boxShadow: 'none',
            WebkitAppearance: 'none',
            appearance: 'none',
            backgroundColor: 'transparent',
            ...(disabled && {
              cursor: 'not-allowed',
              opacity: 0.6,
            }),
          }}
        />
        {value && (
          <span
            style={{
              position: 'absolute',
              right: '8px',
              bottom: '8px',
              fontSize: '16px',
              color: isValid ? '#4C48BE' : '#E65959',
            }}
          >
            {isValid ? <Icon.Check /> : <Icon.Caution />}
          </span>
        )}
      </div>

      {error && (
        <span style={{ color: '#E65959', fontSize: '12px', marginTop: '4px' }}>
          {error}
        </span>
      )}
    </div>
  );
}
